import { render, staticRenderFns } from "./ali-unlink.vue?vue&type=template&id=c779e694&scoped=true&"
import script from "./ali-unlink.vue?vue&type=script&lang=js&"
export * from "./ali-unlink.vue?vue&type=script&lang=js&"
import style0 from "./ali-unlink.vue?vue&type=style&index=0&id=c779e694&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c779e694",
  null
  
)

export default component.exports